<!-- 审批详情 -->
<template>
  <div class="backgroundGrey base-padding">
    <div class="details-card">
      <div class="details-title">
        航班信息
      </div>
      <div class="detailsItem">
        <div>
          <span>航班日期：</span>
          <span>{{ main.flightDate }}</span>
        </div>
        <div>
          <span>航线环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div>
          <span>航段环：</span>
          <span>{{ main.flightLineRing }}</span>
        </div>
      </div>
    </div>
    <div class="details-card">
      <div class="details-title">
        商品信息
      </div>
      <Grid :columns="columns" :tableData="main.details" />
    </div>
    <div class="details-card">
      <div class="details-title">
        基本信息
      </div>
      <div class="detailsItem">
        <div>
          <span>申请单号：</span>
          <span>{{ main.applyNo }}</span>
        </div>
        <div>
          <span>申请人：</span>
          <span>{{ main.applyStaffName }}</span>
        </div>
        <div>
          <span>申请时间：</span>
          <span>{{ main.createdTime }}</span>
        </div>
        <div>
          <span>状态：</span>
          <span>{{ $utils.subAppStatus(main.applyStatus) }}</span>
        </div>
      </div>
    </div>
    <BottomButton v-if="main.isCurrent">
      <van-button type="primary" @click="showReject = true">驳回</van-button>
      <van-button type="primary" @click="agreeConfirm">通过</van-button>
    </BottomButton>
    <van-dialog v-model="showReject" title="确认驳回？" @confirm="confirmReject" show-cancel-button>
      <van-field v-model="remark" rows="2" autosize type="textarea" maxlength="100" placeholder="请输入驳回原因" show-word-limit />
    </van-dialog>
  </div>

</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'
import Grid from '@/components/common/Grid/index.vue'
import BottomButton from '@/components/common/BottomButton'

export default {
  components: {
    EmptyTips,
    Grid,
    BottomButton,
  },
  data() {
    return {
      main: {},
      showReject: false,
      remark: '',
      columns: [
        { label: '商品名称', prop: 'productName' },
        { label: '规格', prop: 'sku' },
        { label: '售价', prop: 'price' },
        { label: '配货数量', prop: 'quantity' },
      ],
    }
  },
  activated() {
    this.main = this.$route.query
    this.getDetailByStaff()
  },
  methods: {
    // 获取详情
    getDetailByStaff() {
      let url = `/api-sys/sell/addMatterSearch/getDetailByStaff?staffId=${this.$store.state.userInfo.userId}&applyId=${this.main.id}`
      this.$api.get(url).then((res) => {
        this.main = res.data
      })
    },
    agreeConfirm() {
      this.$Dialog
        .confirm({
          title: '提醒',
          message: '确认通过审批',
        })
        .then(() => {
          this.approve(1)
        })
        .catch(() => {})
    },
    confirmReject() {
      this.approve(0)
    },
    // 审批
    approve(agree) {
      let params = {
        applyNo: this.main.applyNo,
        staffId: this.$store.state.userInfo.userId,
        companyId: this.$store.state.userInfo.companyId,
        agree: agree /*驳回申请人:0,同意:1*/,
        msg: this.remark /*驳回的信息*/,
      }
      this.$api.post('/api-sys/sell/sellAddMatterWF/approve', params).then((res) => {
        if (res.code === '0000') {
          this.$Toast.success('操作成功')
          setTimeout(() => {
            this.$utils.routerPush({
              name: 'DistributionApproval',
            })
          }, 800)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/DistributionApproval/DistributionApprovalDetails.vue